import './FloatingBar.scss';

import cn from 'classnames';
import { HTMLAttributes, PropsWithChildren } from 'react';

const cssClassName = 'c-FloatingBar';

type Position = 'top' | 'bottom';

type Props = {
  position?: Position;
  shouldUseStickyPosition?: boolean;
} & PropsWithChildren &
  HTMLAttributes<HTMLDivElement>;

export const FloatingBar = ({
  position = 'bottom',
  shouldUseStickyPosition = false,
  children,
  className,
  ...restProps
}: Props) => {
  return (
    <div
      className={cn(
        cssClassName,
        {
          [`${cssClassName}--top`]: position === 'top',
          [`${cssClassName}--bottom`]: position === 'bottom',
          [`${cssClassName}--sticky`]: shouldUseStickyPosition,
        },
        className,
      )}
      {...restProps}
    >
      {children}
    </div>
  );
};
